import ApiService from '@/services/api'

const state = {
  expertises: [],
  loading: false,
  error: null
}

const mutations = {
  SET_EXPERTISES(state, expertises) {
    state.expertises = expertises
  },
  
  SET_LOADING(state, status) {
    state.loading = status
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchExpertises({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await ApiService.get('/Expertise')
      commit('SET_EXPERTISES', response.data)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Erro ao carregar expertises'
      commit('SET_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  allExpertises: (state) => state.expertises,
  
  expertisesCount: (state) => state.expertises.length,
  
  isLoadingExpertises: (state) => state.loading,
  
  expertisesError: (state) => state.error,
  
  getExpertiseById: (state) => (id) => {
    return state.expertises.find(expertise => expertise.id === id)
  },
  
  getExpertiseByName: (state) => (name) => {
    return state.expertises.find(expertise => 
      expertise.name?.toLowerCase() === name.toLowerCase()
    )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}